export default __webpack_public_path__ + "static/media/review_history.b6830691.svg";